import styled from 'styled-components';

// Log de eventos da maquina — lista cronologica (mais recente no topo)
// de alarmes / bloqueios / trips. Visual flat (a Section pai ja prove
// o card), tokens CCO, sem hex hardcoded a nao ser status fixo (que
// tambem vem de var(--cco-*)).
export const LogContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  gap: 14px;
`;

// #4 Top ofensor — barra de resumo da variavel que mais disparou. Tom
// soft pra dar peso sem competir com a lista. So aparece quando ha
// reincidencia relevante (>= 2).
export const TopOffender = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line);
  min-width: 0;

  .lbl {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: var(--cco-ink-faint);
    flex-shrink: 0;
  }
  .cause {
    font-size: 13px;
    font-weight: 700;
    color: var(--cco-ink);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }
  .count {
    margin-left: auto;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    padding: 1px 8px;
    border-radius: 9px;
    background: rgba(232, 65, 65, 0.16);
    border: 1px solid rgba(232, 65, 65, 0.32);
    color: var(--cco-red);
    font-size: 11px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
`;

// #1 Chips de filtro por severidade — pill style, mesma familia das
// abas. O chip ativo ganha fill/borda de tinta; desabilitado (count 0)
// fica esmaecido.
export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const FilterChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 5px 11px;
  border-radius: 999px;
  transition: color 120ms, background 120ms, border-color 120ms;

  ${(props) =>
    props.$active
      ? `
        background: var(--cco-soft-surface);
        border: 1px solid var(--cco-line-strong);
        color: var(--cco-ink);
      `
      : `
        background: transparent;
        border: 1px solid var(--cco-line);
        color: var(--cco-ink-faint);
      `}

  .n {
    font-variant-numeric: tabular-nums;
    font-weight: 800;
    color: ${(props) => (props.$active ? 'var(--cco-ink)' : 'var(--cco-ink-mute)')};
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  &:not(:disabled):hover {
    color: var(--cco-ink);
    border-color: var(--cco-line-strong);
  }
`;

// #2 Divisor de dia — "Hoje" / "Ontem" / data. Caps mute pra ancorar a
// lista temporalmente sem peso visual.
export const DayDivider = styled.div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--cco-ink-faint);
  padding: 14px 6px 6px;
  border-bottom: 1px solid var(--cco-line);
`;

export const LogList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// Item do log: faixa de severidade a esquerda + icone + corpo (severidade
// em caps, causa, timestamp). Borda inferior sutil separa os itens sem
// peso de card individual. Quando clicavel (correlacao com grafico) vira
// <button> — reset de estilo nativo + hover sutil.
export const LogItem = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 6px 12px 14px;
  border-bottom: 1px solid var(--cco-line);
  width: 100%;
  text-align: left;
  font-family: inherit;
  background: transparent;
  ${(props) =>
    props.$clickable
      ? `
        border-left: none;
        cursor: pointer;
        transition: background 120ms;
        &:hover { background: var(--cco-soft-surface); }
      `
      : ''}

  &:last-child {
    border-bottom: none;
  }
`;

// Stripe vertical colorido (severidade) — espelha o padrao usado no
// alert-overlay do mapa pra leitura consistente entre telas.
export const LogStripe = styled.span`
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 2px;
  background: ${(props) => props.$color || 'var(--cco-line-strong)'};
`;

export const LogIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
  color: ${(props) => props.$color || 'var(--cco-ink-mute)'};
`;

export const LogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
`;

export const LogTop = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
`;

export const LogSeverity = styled.span`
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: ${(props) => props.$color || 'var(--cco-ink-mute)'};
  flex-shrink: 0;
`;

export const LogCause = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--cco-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

// #3 Badge de reincidencia ("3x") — variavel que disparou varias vezes
// na janela. Tom mute, neutro (a severidade ja esta no stripe/icone).
export const RecurrenceBadge = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 0 6px;
  height: 16px;
  border-radius: 8px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line-strong);
  color: var(--cco-ink-mute);
  font-size: 10px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

export const LogMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: var(--cco-ink-faint);
  font-variant-numeric: tabular-nums;
`;

export const LogRelative = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 8px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line);
  color: var(--cco-ink-mute);
  font-weight: 600;
`;

// #7 Chip do limite configurado (range). Tom mute, separado visualmente
// do timestamp por nao ser temporal. So aparece quando ha range.
export const LogThreshold = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 8px;
  background: transparent;
  border: 1px dashed var(--cco-line-strong);
  color: var(--cco-ink-mute);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
`;

// #9 Acao de rearme — empurrada pra direita na barra de filtros. Dois
// passos: "Rearmar" -> "Confirmar" (estado $confirm) + "Cancelar". Acao
// com efeito no equipamento, por isso a confirmacao explicita.
export const RearmWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const RearmHint = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: var(--cco-ink-mute);
`;

export const RearmButton = styled.button`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: 999px;
  transition: color 120ms, background 120ms, border-color 120ms;

  ${(props) =>
    props.$confirm
      ? `
        background: var(--cco-orange);
        border: 1px solid var(--cco-orange);
        color: var(--cco-bg);
      `
      : `
        background: transparent;
        border: 1px solid var(--cco-orange);
        color: var(--cco-orange);
      `}

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const RearmCancel = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  color: var(--cco-ink-faint);
  padding: 4px 6px;

  &:hover {
    color: var(--cco-ink-mute);
  }
`;

// #6 "Ver todos / ver menos" — expansor abaixo da lista. Link-style
// discreto, centralizado.
export const SeeMore = styled.button`
  align-self: center;
  margin-top: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: var(--cco-blue);
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 120ms;

  &:hover {
    background: var(--cco-soft-surface);
  }
`;

// Estado vazio / carregando — centralizado, tom muted.
export const LogState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 16px;
  color: var(--cco-ink-faint);
  font-size: 13px;
  text-align: center;

  svg {
    color: var(--cco-line-strong);
  }
`;
